import styled from 'styled-components'

export const ContainerWelcome = styled.div`
    width: 100vw;
    height: 680px;

    .bg {
        position: absolute;
        z-index: -1;
        width: 100vw;
        height: 680px;
        object-fit: cover;
        object-position: right top;
    }
    h1, div {
        color: var(--text-body);
    }
    .content {
        position: absolute;
        right: 14vw;
        margin-top: -60px;
        width: 570px;
        display: flex;
        flex-direction: column;
        h1 {
            margin-top: 10rem;
            margin-bottom: 3rem;
            font-size: 34px;
        }
        p {
            font-size: 18px;
            margin-bottom: 2rem;
            line-height: 2rem;
        }

    }
    @media(max-width: 2000px) {
        .bg {
            object-position: -150px top;
        }
    }
    @media(max-width: 1900px) {
        .bg {
            object-position: -220px top;
        }
    }
    @media(max-width: 1800px) {
        .bg {
            object-position: -300px top;
        }
    }
    @media(max-width: 1700px) {
        .bg {
            object-position: -400px top;
        }
    }
    @media(max-width: 1600px) {
        .bg {
            object-position: -500px top;
        }
    }
    @media(max-width: 1500px) {
        .bg {
            object-position: -600px top;
        }
    }
    @media(max-width: 1350px) {
        .bg {
            object-position: -700px top;
        }
    }
    @media(max-width: 1250px) {
        .bg {
            object-position: -800px top;
        }
    }
    @media(max-width: 1150px) {
        .bg {
            object-position: -900px top;
        }
    }
    @media(max-width: 1050px) {
        .bg {
            object-position: -1000px top;
        }
    }
    @media(max-width: 950px) {
        .bg {
            object-position: -1100px top;
        }
    }


    @media(max-width: 820px) {
        .bg {
            object-position: 95% top;
        }
        .content {
            width: 80vw;
        }
    }

    @media(max-width: 382px) {
        .content {
            right: 9vw;
            h1 {
                font-size: 30px;
            }
            p {
                font-size: 16px;
            }
        }
    }


`